/**
 * Models
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides the application store to all loaded models.
 * These are pre loaded after Start component creation.
 */
export default {
  state: {
    models: {},
  },
  mutations: {
    ADD_MODEL(currentState, payload) {
      currentState.models = { ...currentState.models, ...payload };
    },
  },
  actions: {
    addModel(context, payload) {
      context.commit('ADD_MODEL', payload);
    },
  },
  getters: {
    models(state) {
      return state.models;
    },
  },
};
